var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M4.869 2.834l1.292 1.292a1 1 0 0 1 0 1.414L5.126 6.575c.342.93.923 1.801 1.742 2.612.819.81 1.69 1.417 2.612 1.821l1.086-1.183a1 1 0 0 1 1.39-.08l1.147.989a1 1 0 0 1 .128 1.382l-.545.682a2 2 0 0 1-1.65.749c-2.295-.102-4.265-.974-5.91-2.619C3.463 9.264 2.59 7.155 2.505 4.601a2 2 0 0 1 .798-1.666l.259-.194a1 1 0 0 1 1.307.093z" })
  );
});